import classNames from "classnames";
import React from "react";

export default function Separator({ className = "" }) {
    return <div className={classNames("border-t-[1px] border-blue-light w-full", className)}></div>
}